module.exports = __webpack_public_path__ + "ce954085aedda929690e91311843770d.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/base.jpg
// module id = qU3O
// module chunks = 0